import { render, staticRenderFns } from "./Rebates.vue?vue&type=template&id=1afc07b6&"
import script from "./Rebates.vue?vue&type=script&lang=js&"
export * from "./Rebates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports